<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M29.334 16c0 7.363-5.97 13.333-13.334 13.333-7.363 0-13.333-5.97-13.333-13.334C2.667 8.636 8.637 2.666 16 2.666c7.364 0 13.334 5.97 13.334 13.333zM16.63 10.962a1.01 1.01 0 011.429 0l4.312 4.32a1.014 1.014 0 010 1.432l-4.312 4.321a1.01 1.01 0 01-1.43 0 1.014 1.014 0 010-1.432l2.6-2.605h-8.895a1 1 0 110-2h8.895l-2.6-2.604a1.014 1.014 0 010-1.432z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'arrowsCircleArrowRightOutline'
}
</script>
